/**
 * Ruta `/listo` (US2, T033): fin de la activación. "✓ Todo listo. Tu Fermin está activo."
 *
 * QA-3 de la 005: la pantalla suma la sección **"Prepara tu primera marcación"**
 * (`features/attendance/permissions-prep.tsx`), que pide los permisos de cámara y ubicación antes
 * de la primera marcación para que esa marca no salga sin ubicación. Es omitible y no bloquea: el
 * enlace "Ir al inicio" sigue siendo la acción de la pantalla.
 *
 * Único dueño de la pantalla de fin de activación (`data-testid="activation-done"`, mismo título,
 * texto y enlace de siempre, espacio de nombres `activation`): `features/activation/done.tsx`
 * quedó redundante con esta ruta y se eliminó.
 */
import { createFileRoute, Link } from '@tanstack/react-router';
import { Check } from 'lucide-react';

import { buttonClasses } from '../components/ui/button';
import { Screen } from '../components/ui/screen';
import { PermissionsPrep, type PermissionsPrepProps } from '../features/attendance/permissions-prep';
import { t } from '../i18n';

export interface ListoScreenProps {
  /** Inyección de pruebas para la sección de permisos. */
  prepDeps?: PermissionsPrepProps['deps'];
}

export function ListoScreen({ prepDeps }: ListoScreenProps) {
  return (
    <Screen
      data-testid="activation-done"
      align="center"
      footer={
        <Link to="/" className={buttonClasses()}>
          {t('activation.done.action')}
        </Link>
      }
    >
      <div className="flex flex-col items-center gap-fm-4 text-center">
        <span
          aria-hidden="true"
          className="flex size-24 items-center justify-center rounded-fm-pill bg-fm-success-soft"
        >
          <Check size={48} className="text-fm-success-text" />
        </span>
        <h1 className="font-display text-fm-2xl font-extrabold text-fm-text">
          {t('activation.done.title')}
        </h1>
        <p className="text-fm-base text-fm-text-secondary">{t('activation.done.lead')}</p>
      </div>
      <PermissionsPrep {...(prepDeps === undefined ? {} : { deps: prepDeps })} />
    </Screen>
  );
}

export const Route = createFileRoute('/listo')({
  component: () => <ListoScreen />,
});
